import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ $compact }) => ($compact ? "24px" : "64px")};
`;

const Circle = styled.span`
  width: 36px;
  height: 36px;
  border: 3px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

/**
 * `@keyframes` раньше объявлялись прямо в теле styled-компонента и попадали
 * в глобальную область — при нескольких спиннерах на странице имена конфликтовали.
 */
export function Spinner({ compact = false, label = "Загрузка" }) {
  return (
    <Wrapper
      $compact={compact}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <Circle />
    </Wrapper>
  );
}

export default Spinner;
